import Halls from "./halls";

export default Halls;
